<!-- 'loading' → spinner; 'denied' → 404; 'allowed' → showcase. -->
@switch (gateState) {
  @case ('loading') {
    <div class="loading-state">
      <div class="loading-spinner">
        <i class="fa-solid fa-spinner fa-spin"></i>
      </div>
      <div class="loading-text">Loading test environment...</div>
    </div>
  }
  @case ('denied') {
    <arpio-center-panel>
      <h3 class="panel-title">Page Not Found</h3>
      <div class="margin-top">The page you're looking for doesn't exist or may have been moved.</div>
      <div class="margin-top actions">
        <a class="primary-button" href="/">
          <i class="fa-utility fa-semibold fa-arrow-left"></i>
          Back to home
        </a>
      </div>
    </arpio-center-panel>
  }
  @case ('allowed') {
    <div class="test-page">
      <header class="page-header">
        <div class="header-content">
          <h1>Internal Test Page</h1>
          <p class="header-subtitle">Development environment for testing UI components with mock data.</p>
        </div>
      </header>

      <!-- Sticky section-nav — pinned to top on scroll, sibling of .page-header so it -->
      <!-- doesn't unstick when the header scrolls away. -->
      <nav class="section-nav">
        @for (section of sections; track section.key) {
          <a class="nav-pill" (click)="scrollTo(section)"> <i [class]="section.icon"></i> {{ section.label }} </a>
        }
      </nav>

      <!-- Sections are collapsed by default: they reference mock ARNs that aren't real
           on the backend, which fires a barrage of 404s and (for some issue components)
           NPEs from their ngOnInit. Expanding is also what mounts the child, so nothing
           runs until a reviewer asks for it. -->
      @for (section of sections; track section.key) {
        <section [id]="section.anchor" class="page-section">
          <div class="section-header clickable" (click)="toggleSection(section.key)">
            <h2>
              <i [class]="section.icon" class="section-icon"></i>
              {{ section.title }}
            </h2>
            <i
              class="fa-solid section-chevron"
              [class.fa-chevron-down]="!expandedSections[section.key]"
              [class.fa-chevron-up]="expandedSections[section.key]"
            ></i>
          </div>
          @if (expandedSections[section.key]) {
            <div class="section-body">
              <ng-container *ngComponentOutlet="section.component"></ng-container>
            </div>
          }
        </section>
      }

      <!-- Toast tester: fixed top-right trigger that fires every UiService toast
        variant on top of whatever screen state the reviewer has set up. -->
      <div class="toast-tester" (click)="onPanelClick($event)">
        <button
          type="button"
          class="toast-tester__button"
          [class.is-open]="toastMenuOpen"
          [attr.aria-expanded]="toastMenuOpen"
          aria-label="Trigger test toasts"
          (click)="toggleToastMenu($event)"
        >
          <i class="fa-solid fa-bread-slice"></i>
        </button>
        @if (toastMenuOpen) {
          <div class="toast-tester__panel">
            <div class="toast-tester__panel-header">Trigger a toast</div>
            @for (group of toastGroups; track group) {
              <div class="toast-tester__group">
                <div class="toast-tester__group-label">{{ group.label }}</div>
                @for (variant of group.variants; track variant) {
                  <button type="button" class="toast-tester__option" (click)="fireToast($event, variant.fire)">
                    {{ variant.label }}
                  </button>
                }
              </div>
            }
          </div>
        }
      </div>
    </div>
  }
}
